import React from "react"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import FacilityGroupCodeList from "./FacilityGroupCodeList"

export const useFacilityGroupCodesTabHeading = () => {
  const { name: facilityName } = useCustomName(FACILITY_KEY)

  return `${facilityName} Group Codes`
}

const FacilityGroupCodesTab = () => {
  const facilityGroupCodesTabHeading = useFacilityGroupCodesTabHeading()

  return (
    <>
      <h2 className="tab-title">{ facilityGroupCodesTabHeading }</h2>
      <FacilityGroupCodeList />
    </>
  )
}

export default FacilityGroupCodesTab
